import React, { FC, ReactElement } from 'react';
import styled from 'styled-components';
export const Header = styled.div`
  padding: 1rem 2rem 1rem 2rem; /* top right bottom left  */
  background-color: ${({ theme }) => theme.colors.Snow};
  font-size: ${({ theme }) => theme.fontSize.xl};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;

export const Body = styled.div`
  margin-top: 1rem;
  padding: 1rem 2rem 1rem 2rem; /* top right bottom left  */
  background-color: ${({ theme }) => theme.colors.White};
  flex: 1;
`;

export const SelfServiceContainer = styled.div`
  min-height: 70vh;
  display: flex;
  flex-direction: column;
`;

export interface ISelfServiceLayout {
  header: string | ReactElement;
  body: ReactElement;
}
export const SelfServiceLayout: React.FC<ISelfServiceLayout> = ({
  header,
  body,
}) => {
  return (
    <SelfServiceContainer>
      <Header>{header}</Header>
      <Body>{body}</Body>
    </SelfServiceContainer>
  );
};
